(() => {
  if (customElements.get('product-sticky-bar')) {
    return;
  }

  class ProductStickyBar extends HTMLElement {
    constructor() {
      super();
      this.offset = getOffsetTop(this);
    }

    connectedCallback() {
      this.init();
    }

    init() {
      window.addEventListener('scroll', (e) => {
        window.scrollY >= this.offset
          ? this.removeAttribute('is-hidden')
          : this.setAttribute('is-hidden', true);
      });
    }
  }

  customElements.define('product-sticky-bar', ProductStickyBar);
})();
